/* eslint-disable import/extensions */
import store from '~/store'
import CONSTANTS from '~/global_helper/constants.js'
// eslint-disable-next-line import/named
import { configSettings } from '~/plugins/config-settings'

const MainContainer = () => import('~/components/layouts/MainContainer').then(m => m.default || m)
const DesignSystem = () => import('~/pages/design-system/DesignSystem').then(m => m.default || m)
const NPSSurvey = () => import('~/pages/nps-survey/NPSSurvey').then(m => m.default || m)

const beforeDashboardEnterRedirect = async (to, from, next) => {
	// Check if this is an existing user, that should be sent to GaryVee checkout page since they came from the garyvee challenge page this session
	const cameFromGaryVeeRef = CONSTANTS.GARY_VEE_CHALLENGE.REFERRALS.includes(sessionStorage.getItem('ref')?.toLowerCase())
	if (!cameFromGaryVeeRef) {
		return next()
	}

	if (!store.getters['Auth/user']) {
		await store.dispatch('Auth/fetchUser')
	}
	const user = store.getters['Auth/user']

	const notInExperiment = !user?.experiments?.gary_vee_challenge_experiment

	if (notInExperiment) {
		// No need for session level redirect after this
		sessionStorage.removeItem('ref')
		const urlBase =
			configSettings.env_name === 'production'
				? CONSTANTS.GARY_VEE_CHALLENGE.PROD_COMMUNITY_LINK
				: CONSTANTS.GARY_VEE_CHALLENGE.STAGING_COMMUNITY_LANDING_PAGE
		window.open(`${urlBase}?name=${encodeURIComponent(user?.full_name)}&email=${encodeURIComponent(user?.email)}`, '_self')
		return false
	}

	return next()
}

const moduleRoutes = [
	{
		path: '/dashboard',
		name: 'DashboardIndex',
		beforeEnter: beforeDashboardEnterRedirect,
		component: MainContainer,
		props: true,
		children: [
			{
				path: '',
				name: 'dashboard',
				component: () => import('~/pages/dashboard/Dashboard').then(m => m.default || m),
				props: true,
				meta: { pageTitle: 'Dashboard', breadcrumbs: [{ title: 'Home', active: true }], showAppBanner: true },
			},
		],
	},
	{
		path: '/ask-stanley',
		name: 'AskStanleyIndex',
		component: MainContainer,
		props: true,
		children: [
			{
				path: '',
				name: 'ask_stanley',
				component: () => import('~/pages/ask-stanley/AskStanley').then(m => m.default || m),
				meta: { pageTitle: 'Ask Stanley & Get Help', breadcrumbs: [{ title: 'Ask Stanley & Get Help', active: true }] },
			},
		],
	},
	{
		path: '/apps',
		component: MainContainer,
		props: true,
		children: [
			{
				path: '',
				name: 'apps',
				component: () => import('~/pages/apps/NavigationApps').then(m => m.default || m),
				meta: { pageTitle: 'More Options', breadcrumbs: [{ title: 'More Options', active: true }] },
			},
		],
	},
	{
		// path: '/nps_campaign/:token/:score',
		path: '/nps_campaign',
		name: 'nps_survey',
		component: NPSSurvey,
	},
	{
		path: '/design-system',
		name: 'design-system',
		component: DesignSystem,
	},
	{
		path: '/profile',
		name: 'ProfileIndex',
		component: MainContainer,
		props: true,
		children: [
			{
				path: '',
				name: 'profile',
				component: () => import('~/pages/stores/Profile').then(m => m.default || m),
				meta: {
					pageTitle: 'Header',
					breadcrumbs: [
						{ title: 'My Store', to: 'linksites' },
						{ title: 'Header', active: true },
					],
				},
			},
		],
	},
	{
		path: '/connect-stripe',
		name: 'ConnectStripe',
		component: MainContainer,
		props: true,
		children: [
			{
				path: '',
				name: 'connect_stripe',
				component: () => import('~/pages/dashboard/ConnectStripePage').then(m => m.default || m),
				meta: {
					pageTitle: 'Connect Stripe',
					breadcrumbs: [
						{ title: 'Home', to: 'dashboard' },
						{ title: 'Connect Stripe', active: true },
					],
				},
			},
		],
	},
	{
		path: '/internal',
		name: 'internalIndex',
		component: MainContainer,
		props: true,
		children: [
			{
				path: 'buttons',
				name: 'buttons',
				component: () => import('~/pages/internal/Buttons').then(m => m.default || m),
				props: true,
				meta: { pageTitle: 'Dashboard', breadcrumbs: [{ title: 'Internal', active: true }], showAppBanner: true },
			},
			{
				path: 'inputs',
				name: 'inputs',
				component: () => import('~/pages/internal/Inputs').then(m => m.default || m),
				props: true,
				meta: { pageTitle: 'Dashboard', breadcrumbs: [{ title: 'Internal', active: true }], showAppBanner: true },
			},
		],
	},
]

export default moduleRoutes
